import { Middleware } from '@nuxt/types';

const enforceOrganizerRoleMiddleware: Middleware = context => {
  if (!context.$auth.$state.loggedIn) {
    // "auth" middleware will enforce this
    return;
  }

  const isUserOrganizer = context.store.getters['settings/isOrganizer'];
  if (!isUserOrganizer) {
    const errorMessage = context.app.i18n.t('shared.error.server_validation.authorization_error');
    context.app.$toast.error(errorMessage);
    context.$auth.redirect('home');
  }
};

export default enforceOrganizerRoleMiddleware;
